

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { MSResponse } from '@/interfaces/MS';
import { AxiosResponse } from 'axios';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';

@Component({
  name: 'Datatables',
  components: {},
})
export default class WidgetControl extends Vue {
  @Prop({ default: [] }) widgetList!: { title: string; value: any; key: any }[];
  loadingService = new LoadingService();
  widgetSelected: any = '';
  $snotify: any;
  filtroWidget(item: any) {
    let list: any;
    let tipo: any = item.key;
    let new_selected = item.title.replace(' ', '_');
    if (
      this.widgetSelected == new_selected ||
      new_selected == 'TOTAL_VEHICULOS'
    ) {
      list = document.querySelectorAll('.dashboard #cardDashboard.disabled');
      for (let i = 0; i < list.length; ++i) {
        list[i].classList.remove('disabled');
      }
      this.widgetSelected = null;
      TorreControlInstance.$emit('filtroWidgets', 0, this.widgetList);
      return;
    }
    TorreControlInstance.$emit('filtroWidgets', tipo, this.widgetList);
    list = document.querySelectorAll('.dashboard #cardDashboard.disabled');
    for (let i = 0; i < list.length; ++i) {
      list[i].classList.remove('disabled');
    }
    list = document.querySelectorAll(
      '.dashboard #cardDashboard:not(.' + new_selected + ')'
    );
    for (let i = 0; i < list.length; ++i) {
      list[i].classList.add('disabled');
    }
    this.widgetSelected = new_selected;
    TorreControlInstance.$emit('selectWidget', tipo);
  }
}
